// context/AuthContext.js
import React, { createContext, useState, useContext, useEffect } from 'react';

const AuthContext = createContext();

export const AuthProvider = ({ children }) => {
  const [user, setUser] = useState(null);
  const [idToken, setIdToken] = useState(null);
  const [isLoading, setIsLoading] = useState(true);

  // Load user from session storage on initial mount
  useEffect(() => {
    const storedUser = sessionStorage.getItem('user');
    const storedIdToken = sessionStorage.getItem('idToken');

    if (storedUser && storedIdToken) {
      setUser(JSON.parse(storedUser));
      setIdToken(storedIdToken);
    }

    setIsLoading(false);
  }, []);

  const login = (userData, token) => {
    // Save to state
    setUser(userData);
    setIdToken(token);

    sessionStorage.setItem('user', JSON.stringify(userData));
    sessionStorage.setItem('idToken', token);
  };

  const logout = () => {
    setUser(null);
    setIdToken(null);

    sessionStorage.removeItem('user');
    sessionStorage.removeItem('idToken');
  };

  const updateUser = (updatedUserData) => {
    setUser(prev => ({ ...prev, ...updatedUserData }));
    const storedUser = sessionStorage.getItem('user');
    if (storedUser) {
      const userObj = JSON.parse(storedUser);
      const newUser = { ...userObj, ...updatedUserData };
      sessionStorage.setItem('user', JSON.stringify(newUser));
    }
  };

  return (
    <AuthContext.Provider value={{ user, idToken, login, logout, updateUser, isLoading }}>
      {children}
    </AuthContext.Provider>
  );
};

export const useAuth = () => useContext(AuthContext);